import { observer } from "mobx-react-lite";

import { SymbolNode } from "@/components/expression/SymbolNode";
import * as Node from "@/components/expression/utils/layout";
import { NodeStyleProvider, useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";
import { EditNodeInput } from "@/components/input/EditNodeInput";
import { getIndentationAttrs } from "@/components/tiptap/utils/indentation";
import { isRelation } from "@/models/utils/semanticChecks";
import { twMerge } from "@/utils/twMerge";

import type { ExpressionComponent } from "./types";
import type { Text } from "@/components/expression/utils/NodeStyleProvider";

export const OperatorSymbolNode: ExpressionComponent<"operatorSymbol"> = observer(
  function OperatorSymbolNode({ node, className }) {
    const { view, size } = useNodeStyle();
    const attrs = getIndentationAttrs(node);

    const isTextView = view === "text";
    const isRelationshipOperator = isRelation(node);
    const isPunctuationOperator = node.semanticTypes?.includes("punctuation");
    const textStyle: Text | undefined = isTextView ? undefined : "primary";

    return (
      <EditNodeInput node={node} inputClassName={twMerge("rounded-4", className)}>
        <div
          className={twMerge("px-0.1", size === "xs" && "px-0.1", isTextView && "px-0", className)}
        >
          <Node.Container
            node={node}
            dimension={isRelationshipOperator ? "square" : "narrow"}
            className={twMerge(
              "inline-flex rounded-4 px-0.5",
              isPunctuationOperator && "min-w-2.5 px-0",
              isTextView && "rounded-none",
            )}
            disableHover
            {...attrs}
          >
            <NodeStyleProvider placeholderVisible="none" text={textStyle}>
              {node.symbolNode && <SymbolNode node={node.symbolNode} />}
            </NodeStyleProvider>
          </Node.Container>
        </div>
      </EditNodeInput>
    );
  },
);
